// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  min-height: 160px;
}

.bar-section .row {
  margin: 0;
}

/* .bar-section .tab-column {
  background: #000;
  color: white;
  text-align: left;
  max-width: 960px;
  /* padding: 16px 20px; */
/* font-size: 20px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 8px;
} */
.bar-section .tab-column {
  background-color: #262626; /* Default background color */
  color: white; /* Default text color */
  text-align: left;
  padding: 15px 20px;
  font-size: 20px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

/* .aptsi-card {
  max-width: 960px;
} */
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto 28px;
}

.step-pill {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 999px;
  border: 2px solid #9aa8b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #607086;
  background: #fff;
}

.step-pill.active {
  border-color: #0d6efd;
  background: #0d6efd;
  color: #fff;
}

.step-line {
  flex: 1 1 20px;
  max-width: 36px;
  height: 2px;
  background: #cfd8e3;
}

.step-copy {
  margin-bottom: 24px;
}

.step-copy h3 {
  margin-bottom: 8px;
  font-size: 28px;
  color: #1d2a38;
}

.step-copy p {
  margin: 0;
  color: #5f6f82;
}

.summary-card {
  margin-top: 24px;
  padding: 18px 20px;
  border: 1px solid #d8e1eb;
  border-radius: 12px;
  background: white;
}

.summary-title {
  font-size: 16px;
  font-weight: 700;
  color: #1d2a38;
  margin-bottom: 10px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #d8e1eb;
}

.summary-row:last-child {
  border-bottom: 0;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #1a1a86;
}

@media (max-width: 768px) {
  .summary-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .step-copy h3 {
    font-size: 24px;
  }
  .step-indicator {
    gap: 4px;
  }
  .step-pill {
    width: 26px;
    height: 26px;
    min-width: 26px;
    font-size: 11px;
  }
  .step-line {
    max-width: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/insight-egrc/risk-management/risk-register/risk-register-create-or-update/risk-register-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;;;;;0BAAA;AAMA;;;GAAA;AAIA;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AACF;;AACA;;GAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AACF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE;IACE,sBAAA;IACA,uBAAA;EAAF;EAGA;IACE,eAAA;EADF;EAIA;IACE,QAAA;EAFF;EAKA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAHF;EAMA;IACE,eAAA;EAJF;AACF","sourcesContent":["textarea {\n  min-height: 160px;\n}\n\n.bar-section .row {\n  margin: 0;\n}\n\n/* .bar-section .tab-column {\n  background: #000;\n  color: white;\n  text-align: left;\n  max-width: 960px;\n  /* padding: 16px 20px; */\n/* font-size: 20px;\n  border: 1px solid rgb(204, 202, 202);\n  border-radius: 8px;\n} */\n.bar-section .tab-column {\n  background-color: #262626; /* Default background color */\n  color: white; /* Default text color */\n  text-align: left;\n  padding: 15px 20px;\n  font-size: 20px;\n  border: 1px solid rgb(204, 202, 202);\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n/* .aptsi-card {\n  max-width: 960px;\n} */\n\n.step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto 28px;\n}\n\n.step-pill {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 999px;\n  border: 2px solid #9aa8b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #607086;\n  background: #fff;\n}\n\n.step-pill.active {\n  border-color: #0d6efd;\n  background: #0d6efd;\n  color: #fff;\n}\n\n.step-line {\n  flex: 1 1 20px;\n  max-width: 36px;\n  height: 2px;\n  background: #cfd8e3;\n}\n\n.step-copy {\n  margin-bottom: 24px;\n}\n\n.step-copy h3 {\n  margin-bottom: 8px;\n  font-size: 28px;\n  color: #1d2a38;\n}\n\n.step-copy p {\n  margin: 0;\n  color: #5f6f82;\n}\n\n.summary-card {\n  margin-top: 24px;\n  padding: 18px 20px;\n  border: 1px solid #d8e1eb;\n  border-radius: 12px;\n  background: white;\n}\n\n.summary-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1d2a38;\n  margin-bottom: 10px;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 8px 0;\n  border-bottom: 1px solid #d8e1eb;\n}\n\n.summary-row:last-child {\n  border-bottom: 0;\n}\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover {\n    background-color: #1a1a86;\n  }\n}\n\n@media (max-width: 768px) {\n  .summary-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .step-copy h3 {\n    font-size: 24px;\n  }\n\n  .step-indicator {\n    gap: 4px;\n  }\n\n  .step-pill {\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    font-size: 11px;\n  }\n\n  .step-line {\n    max-width: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
